import { render, staticRenderFns } from "./PaymentPlanTypesSelectbox.vue?vue&type=template&id=b967aa24"
import script from "./PaymentPlanTypesSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentPlanTypesSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports